import { AuthModeService } from "./auth-mode.service";
import { NotificationService } from "./notification.service";
import { SaffronRegistryService } from "./saffron.registry.service";
import { TelemetryService } from "./telemetry.service";
import { UserService } from "./user.service";

export * from "./auth-mode.service";
export * from "./authentication.service";
export * from "./external-authentication.service";
export * from "./notification.service";
export * from "./portal-authentication.service";
export * from "./saffron.registry.service";
export * from "./telemetry.service";
export * from "./user.service";

export const appServices = [
  AuthModeService,
  NotificationService,
  UserService,
  SaffronRegistryService,
  TelemetryService,
];
